import { Alert, Toast, Spinner } from "react-bootstrap";
import { InfoIcon, TickIcon, WarningIcon } from "../icons/otherIcons";
import { FilledCrossIcon } from "../icons/btnIcons";

const CustomToast = ({ toast, onClose }) => {
  const { message, variant } = toast;

  const renderIcon = () => {
    switch (variant) {
      case "success":
        return <TickIcon size={20} />;
      case "danger":
      case "error":
        return <FilledCrossIcon size={20} />;
      case "warning":
        return <WarningIcon size={20} />;
      case "loading":
        return <Spinner animation="border" size="sm" />;
      case "info":
      default:
        return <InfoIcon size={20} />;
    }
  };

  return (
    <Toast
      show
      onClose={onClose}
      delay={variant === "danger" ? 4000 : variant === "loading" ? 10000 : 2500}
      autohide={variant !== "loading"}
      className="mb-2 bg-transparent w-auto text-end border-0 shadow-none"
    >
      <Alert
        variant={variant === "error" ? "danger" : variant}
        className="m-0 shadow-sm"
      >
        <Alert.Heading className="d-flex align-items-center gap-3">
          {renderIcon()}
          <span>{message}</span>
        </Alert.Heading>
      </Alert>
    </Toast>
  );
};

export default CustomToast;
